import React, { useMemo } from 'react';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import checkImage from '../../../assets/img/check2.png'
import './progressStepper.scss'

const ProgressStepper = ({ steps = 2, filledBackground = "green", percent = 0, showStepper = false, className='', isEntrepreneur=false }) => {

  const currentPercent = useMemo(() => {
    return percent
  }, [percent])

  if (!showStepper) return null

  return (
    <div className={`progress-bar-stepper bg-white rounded-2xl py-1.5 dark:bg-[#FFFFFF] transition duration-300 drop-shadow-md sticky top-20 ${className}`}>
      <div className="mx-10">
        <ProgressBar
          filledBackground={filledBackground}
          percent={currentPercent}
          height={'2px'}
          width={'100%'}
        >

          {
            [...Array(steps)].map((_, index) => {
              let isStartButton = ((index + 1) === 1)
              let isEndButton = ((index + 1) === steps)
              return (
                <Step key={index} transition="scale" index={index+1}>
                  {({ accomplished }) => (
                    <p className={`${accomplished ?
                      isStartButton ? `${isEntrepreneur ? 'bg-[#0198e1]' : 'bg-[#008000]'} rounded-md py-1 px-3 font-medium`
                        : isEndButton ? `${isEntrepreneur ? 'bg-[#0198e1]' : 'bg-[#008000]'} py-1 px-3 rounded-md`
                          : `${isEntrepreneur ? 'bg-[#0198e1]' : 'bg-[#008000]'} py-[10px] px-[8px] text-white rounded-full`
                      : isEndButton
                        ? 'bg-white text-black dark:bg-[#FFFFFF] dark:text-[#000000]  border border-slate-500 rounded-md py-1 px-3 text-black font-medium'
                        : 'border border-slate-500 text-black px-[10px] py-[4px] rounded-full'
                      }
`
                    }
                    >
                      {isStartButton ? 'Start' : isEndButton ? 'End' :
                        accomplished
                          ? <img src={checkImage} alt="" className="w-[12px]" />
                          : (index)
                      }
                    </p>
                  )}
                </Step>
              )
            })
          }
        </ProgressBar>
      </div>
    </div>
  );
};

export default ProgressStepper;



